import { IParamsGetList } from "./list-reports.interface";
import { IGetListReportsAction, ListReportTypes } from "./list-reports.type";

export const getListReports = (
  param?: IParamsGetList
): IGetListReportsAction => ({
  type: ListReportTypes.GET_LIST_REPORT,
  param,
});
